/**
 * Csv Schema of CargaAryzta
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {CargaAryzta} from '@/model/resource/CargaAryzta'

/* TODO: review generated schema */
export class CsvCargaAryztaSchema extends Schema {
  readonly name = 'CsvCargaAryzta'

  readonly fieldSet: FieldSet<CargaAryzta> = {
    idcargaPk: schema => schema.model.idcargaPk,
    dataCriacao: schema => Helper.datetime(schema.model.dataCriacao),
    cgcEmissorNf: schema => schema.model.cgcEmissorNf,
    serieNotaFiscal: schema => schema.model.serieNotaFiscal,
    danfe: schema => schema.model.danfe,
    nrNotaFiscal: schema => schema.model.nrNotaFiscal,
    siglaCliente: schema => schema.model.siglaCliente,
    cepCliente: schema => schema.model.cepCliente,
    dataEmissaoNota: schema => schema.model.dataEmissaoNota,
    dataSaidaMerc: schema => schema.model.dataSaidaMerc,
    tipoFrete: schema => schema.model.tipoFrete,
    nomeTransp: schema => schema.model.nomeTransp,
    codigoCfop: schema => schema.model.codigoCfop,
    denominacaoCfop: schema => schema.model.denominacaoCfop,
  }
}
